import { TUserInfoType } from "@/module/login";
import { reactive, ref } from "vue";

export const menuList = reactive([{
    id: 1,
    name: '专题录播',
    path: "recordedBroadcast",
    isSelect: false
}, {
    id: 2,
    name: '专题直播',
    path: "liveBroadcast",
    isSelect: false
}, {
    id: 3,
    name: '资料库',
    path: "database",
    isSelect: false
}, {
    id: 6,
    name: '任务中心',
    path: "task",
    isSelect: false,
}, {
    id: 7,
    name: '数据监控',
    path: "dataMonitor",
    isSelect: false,
}, {
    id: 4,
    name: '监控列表',
    path: "monitorIndex",
    isSelect: false
}, {
    id: 5,
    name: '数据中心',
    path: "",
    isSelect: false,
}]);
// 获取当前用户信息
let person = reactive({
    userInfo: <TUserInfoType>{}
})
const menu = ref<any>(null)

export function getMenuData() {
    person.userInfo = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("userinfo"))));
    menuList.forEach((item: any) => {
        if (item.id === 1) {
            item.isShow = person.userInfo.RecordIsShow
            item.content = '1'
        } else if (item.id === 2) {
            item.isShow = person.userInfo.LiveIsShow
            item.content = '1'
        } else if (item.id === 3) {
            item.isShow = person.userInfo.FileIsShow
            item.content = '1'
        } else if (item.id === 4) {
            item.isShow = person.userInfo.EquipmentIsShow
            item.content = '1'
        }
    })
    const menuLists = menuList.filter((item: any) => { if (item.isShow && item.content) { return item } })
    const indexs = Number(localStorage.getItem('navIndex'))
    if (indexs) {
        if (menuLists.length) menuLists[indexs].isSelect = true
    } else {
        if (menuLists.length) menuLists[0].isSelect = true
    }
    menu.value = menuLists
    return menuLists
}

export { menu }




